import { useGenUiI18n } from '../../../../shared/ui/i18n.js';
import { sumItems } from '@voll-intelligence/intelligence-ui-kit/checkout';
import type { CheckoutCardSlots } from '../../ui/card_slots.js';
import { SummaryFoot } from '../../ui/summary_foot.js';
import { oneClickLive, travelsAlone } from '../checkout_loyalty.js';
import { RentalCheckoutLoyalty } from './checkout_loyalty.js';
import {
  RentalCheckoutContract,
  rentalDaysNote,
  type RentalCheckoutItem,
} from './checkout_contract.js';

/** O card do carro: o «Contrato» de cada carro (o agente emite um), a
 *  conferência do 1-Click, a fidelidade de quem
 *  viaja sozinho e o rodapé com o total — «pelas N diárias» quando o
 *  carro é um só. */
export function RentalCheckoutCard({
  items,
  slots,
}: {
  readonly items: readonly RentalCheckoutItem[];
  readonly slots: CheckoutCardSlots;
}) {
  const { t } = useGenUiI18n();
  const [only, ...rest] = items;
  const caption = only && rest.length === 0 ? rentalDaysNote(only, t) : undefined;
  return (
    <>
      <div className="checkout__body">
        {items.map((item) => (
          <RentalCheckoutContract key={item.offerId} item={item} />
        ))}
      </div>
      {slots.review}
      <RentalCheckoutLoyalty
        items={items}
        self={travelsAlone(slots.checkout)}
        record={!oneClickLive(slots.flow)}
      />
      <SummaryFoot
        valueKey="common.total"
        value={sumItems(items)}
        {...(caption ? { caption } : {})}
        inPolicy={slots.flow.withinPolicy}
        shieldAriaKey="productCheckout.outOfPolicy"
        shieldTitleKey="productCheckout.outOfPolicy"
        actions={slots.actions('productCheckout.reserveRental')}
      />
    </>
  );
}
